import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { cableId, type CableId } from './Cable.js'

/** Represents the view public.sensor_list_by_cable */
export default interface SensorListByCableTable {
  /** Database type: pg_catalog.int4 */
  cableId: ColumnType<CableId, never, never>

  /** Database type: pg_catalog.int4 */
  cableSerial: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.text */
  sensorId: ColumnType<string, never, never>

  /** Database type: pg_catalog.int4 */
  calibrationId: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.int4 */
  sensorNumber: ColumnType<number, never, never>

  /** Database type: pg_catalog.numeric */
  calibrationOffset: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.timestamptz */
  calibrationDate: ColumnType<Date, never, never>
}

export type SensorListByCable = Selectable<SensorListByCableTable>

export const sensorListByCable = z.object({
  cableId: cableId,
  cableSerial: z.number().nullable().optional(),
  sensorId: z.string(),
  calibrationId: z.number().nullable().optional(),
  sensorNumber: z.number(),
  calibrationOffset: z.number().nullable().optional(),
  calibrationDate: z.coerce.date(),
}) as unknown as z.Schema<SensorListByCable>
